import { render, staticRenderFns } from "./employer-performance-list.vue?vue&type=template&id=0b03867f&scoped=true"
import script from "./employer-performance-list.vue?vue&type=script&lang=js"
export * from "./employer-performance-list.vue?vue&type=script&lang=js"
import style0 from "./employer-performance-list.vue?vue&type=style&index=0&id=0b03867f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b03867f",
  null
  
)

export default component.exports